import React, { FC } from 'react';
import { useOrganizationQuery } from '../../../../api/queries/use-organization-query';
import { OrganizationLocation } from '../../../../types';
import { OrgQueryKeys } from '../../../../api/config';
import { toSiteDisplayNameFromOrganizationLocation } from '../../../../utils/data-mapping';
import { AgisticsSelect } from '../../../shared/agistics-select';
import { L } from 'harmony-language';
import { Button } from '@mui/material';

interface Step1Props {
    selectedOrganizationLocationId: number;
    setSelectedOrganizationLocationId: (n: number) => void;
    onNext: () => void;
}

export const Step1: FC<Step1Props> = (props) => {
    const { selectedOrganizationLocationId, setSelectedOrganizationLocationId, onNext } = props;
    const { data: organizationLocations = [] } = useOrganizationQuery<OrganizationLocation[]>(OrgQueryKeys.locations);

    const organizationLocationItems = organizationLocations.map(organizationLocation => ({
        id: organizationLocation.id,
        value: toSiteDisplayNameFromOrganizationLocation(organizationLocation),
    }));

    return (
        <div>
            <AgisticsSelect
                item={selectedOrganizationLocationId}
                items={organizationLocationItems}
                onChange={(organizationLocationId) => {
                    setSelectedOrganizationLocationId(organizationLocationId);
                }}
                label={L.location()}
                showNone={true}
            />
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '1rem' }}>
                <Button
                    variant='contained'
                    color='primary'
                    onClick={onNext}
                >
                    {L.next()}
                </Button>
            </div>
        </div>
    );
};
